import BaseComponent from "../components/BaseComponent";
import {Panel, SplitCol, SplitLayout, View} from "@vkontakte/vkui";

import MallsList from "../references/mallsList";
import SalePoint from "../references/Klients/salePoint";
import React from "react";
import {AdaptivityContext} from "../assets/constants";


class FragmentMalls extends BaseComponent {


    constructor(props) {
        super(props)
        const state = {

            activePanelMalls: "panel_malls_list",
            current_mall: null,
            getImageEventName: "setImage",

            // Сохраняем состояние списка ТЦ при переключении панелей
            listState: null,
        }

        this.state = {
            ...this.state,
            ...state
        }
    }

    // Callback для сохранения состояния списка
    saveListState = (listState) => {
        this.setState({ listState })
    }

    render() {
        return <View activePanel={this.state.activePanelMalls} id="malls_story">
            <Panel id="panel_malls_list">
                <SplitLayout>
                    {AdaptivityContext.isMobile ? '' : this.MainMenu()}
                    <SplitCol>
                        <MallsList 
                            current_user={this.props.current_user}
                            savedListState={this.state.listState}
                            onSaveListState={this.saveListState}
                        />
                    </SplitCol>
                    {!AdaptivityContext.isMobile &&
                        <SplitCol>

                        </SplitCol>}
                </SplitLayout>
            </Panel>
            <Panel id="panel_malls_item">
                <SplitLayout>
                    {AdaptivityContext.isMobile ? '' : this.MainMenu()}
                    <SplitCol>
                        <SalePoint
                            current_user={this.props.current_user}
                            item={this.state.current_mall}
                            base_url={this.state.base_url}
                            hideForm={() => this.setState({
                                current_mall: null,
                                activePanelMalls: 'panel_malls_list'
                            })}
                            change={this.editCurrentMall}
                        />
                    </SplitCol>
                    {!AdaptivityContext.isMobile && <SplitCol>
                    </SplitCol>}
                </SplitLayout>
            </Panel>

        </View>
    }

    receiveMessage = (event) => {
        if (event.data.type !== undefined && event.data.type === 'setCurrentMall') {

            this.setState({
                current_mall: event.data.value,
                activePanelMalls: event.data.value && event.data.value.id ? 'panel_malls_item' : 'panel_malls_list'
            })
            return
        }

    }


    editCurrentMall = (e, fieldName) => {
        const {current_mall} = this.state
        ///console.log(e)
        if (e.unrestricted_value !== undefined) {
            current_mall.dadata_object = e
            current_mall.full_address = e.value
        } else {
            current_mall[fieldName] = e.currentTarget.value
        }
        this.setState({current_mall})
    }
}

export default FragmentMalls